import { render, staticRenderFns } from "./ArticleSort.vue?vue&type=template&id=3824e48b&scoped=true"
import script from "./ArticleSort.vue?vue&type=script&lang=js"
export * from "./ArticleSort.vue?vue&type=script&lang=js"
import style0 from "./ArticleSort.vue?vue&type=style&index=0&id=3824e48b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3824e48b",
  null
  
)

export default component.exports